interface SignupRightLayoutProps {
  children: React.ReactNode;
}

export const SignupRightLayout = ({ children }: SignupRightLayoutProps) => {
  return (
    <div className="w-full lg:w-[40%] self-stretch glass-panel-light flex flex-col relative">
      {children}
    </div>
  );
};
